<template>
  <svg
    class="oct-icon"
    :class="[
      `oct-icon__${icon}`,
      {
        'oct-icon--active': active
      }
    ]"
    :viewBox="`0 0 ${width} ${height}`"
  >
    <use :xlink:href="`#oct-icon__${icon}`"></use>
  </svg>
</template>

<script>
export default {
  name: 'OctIcon',
  props: {
    /** Icon name */
    icon: {
      type: String,
      default: ''
    },
    /** Width */
    width: {
      type: Number,
      default: 20
    },
    /** Height */
    height: {
      type: Number,
      default: 20
    },
    active: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss">
@import "../theme/variables";

._mp {
  fill:#3b1e87;
}

._mg {
  fill:#73797c;
}
</style>